module.exports = __webpack_public_path__ + "static/img/icon-location.7ff34359.png";